export default {
  SuffixFormField__ARIA: "Suffix",
  SuffixFormField__LABEL: "Suffix",
};
